import {Component, Input} from '@angular/core';
import {ModalDialogDismissOption} from '@shared/confirmation-dialog/modal-dialog-dismiss-option';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {UpdatableGateway} from '@models/adminstration/gateway/updatable-gateway';

@Component({
    selector: 'scitis-admin-gateway-update',
    templateUrl: './gateway-update.component.html',
    styleUrls: ['./gateway-update.component.scss'],
    standalone: false
})
export class GatewayUpdateComponent {

  @Input()
  updatableGateways: UpdatableGateway[] = new Array<UpdatableGateway>();

  constructor(private activeModal: NgbActiveModal) { }

  onClose(){
    this.activeModal.dismiss(ModalDialogDismissOption.CLOSE);
  }

  onCancel(){
    this.activeModal.dismiss(ModalDialogDismissOption.CANCEL);
  }

  update(){
    const updatableGatewayIds: string[] = new Array<string>();
    for(const gateway of this.updatableGateways){
      if(gateway.selected){
        updatableGatewayIds.push(gateway.id);
      }
    }
    this.activeModal.close(updatableGatewayIds);
  }

  isUpdateButtonDisabled(){
    if(this.updatableGateways.length < 1){
      return true;
    }
    for(const gateway of this.updatableGateways){
      if(gateway.selected){
        return false;
      }
    }
    return true;
  }

}
